/** Figma Navigation Theme — deep violet bloom (not brand magenta) */
const SIDEBAR_SHINE = {
  highlight: "91, 42, 138",
  mid: "59, 26, 96"
};

const APP_SHELL_BACKGROUND = [
  `radial-gradient(ellipse 65% 50% at 12% 8%, rgba(${SIDEBAR_SHINE.highlight}, 0.55) 0%, rgba(${SIDEBAR_SHINE.mid}, 0.28) 38%, transparent 68%)`,
  `radial-gradient(ellipse 42% 36% at 18% 45%, rgba(${SIDEBAR_SHINE.mid}, 0.35) 0%, transparent 62%)`,
  `radial-gradient(ellipse 70% 40% at 8% 0%, rgba(${SIDEBAR_SHINE.highlight}, 0.18) 0%, transparent 55%)`,
  "linear-gradient(180deg, #21132F 0%, #151022 38%, #0E0C14 72%, #0A0810 100%)"
].join(", ");

const COLORS = {
  paper: "#FFFFFF",
  background: "#0E0C14",
  text: "#fefeff",
  textGray: "#6E6D7A",
  disabled: "#919EAB",
  primary: "#1E98D9",
  secondary: "#0F123D",
  info: "#875BF7",
  success: "#09B985",
  warning: "#F59E0B",
  error: "#FF4D5E",
  white: "#fff",
  black: "#000",
  brand: {
    purple: "#D20ED2",
    blue: "#1E98D9"
  },
  surface: {
    page: "#F3F3F3",
    card: "#FFFFFF",
    border: "#E8EBF2",
    tableHeader: "#F8FAFC",
    selection: "#EBF5FF",
    primaryText: "#1E2229",
    secondaryText: "#626C7A",
    mutedText: "#9CA4B3",
    track: "#F0F2F5"
  },
  chart: {
    zone: "#9333EA",
    distress: "#4F46E5",
    fall: "#38BDF8",
    abuse: "#EC4899",
    weapon: "#34D399",
    abusive: "#F97316"
  },
  custom: {
    background: "#DFDFDF",
    lightblue: "#5CCFFF",
    blue: "#281AC8",
    purple: "#D20ED2",
    pink: "#CE6CD2",
    yellow: "#EDC110",
    prelude: "#D3C7E5",
    silver: "#C7C7C7",
    warning: "#e7cb024d",
    navActive: "rgba(15, 18, 61, 0.72)",
    navActiveText: "#5CCFFF",
    navIdle: "#CBD2CB"
  },
  gradients: {
    button: {
      left: "#D20ED2",
      right: "#1E98D9"
    },
    background: {
      top: "#21132F",
      bottom: "#0E0C14"
    },
    sidebar: {
      top: "#21132F",
      mid: "#151022",
      bottom: "#0E0C14"
    }
  },
  /** Figma Navigation Theme — Sidebar base gradient */
  sidebarGradient: "linear-gradient(180deg, #21132F 0%, #151022 45%, #0E0C14 100%)",
  /** Full-viewport shell: one continuous gradient from sidebar through content chrome */
  appShellBackground: APP_SHELL_BACKGROUND,
  sidebarBackground: APP_SHELL_BACKGROUND,
  radius: {
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    pill: 999
  },
  shadow: {
    card: "0px 4px 6px rgba(0, 0, 0, 0.02), 0px 8px 12px rgba(0, 0, 0, 0.05)",
    panel: "0 8px 40px rgba(14, 12, 20, 0.18)",
    modal: "0 8px 32px rgba(14, 12, 20, 0.28)"
  }
};
export default COLORS;
